"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordTitleFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const comparisons_1 = require("../../comparisons/comparisons");
const fields_1 = require("../../utils/fields");
const google_sheet_1 = require("../../utils/google-sheet");
const base_text_fieldtype_1 = require("../base-fields/base-text.fieldtype");
const text_field_validators_1 = require("../text-field/text-field.validators");
const texts_1 = require("../../texts");
const intl_1 = require("../../locale/intl");
const validation_1 = require("../../validation/validation");
class RecordTitleFieldLogic extends base_text_fieldtype_1.BaseTextFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "recordtitlefield";
        this.label = (0, intl_1.$t)(texts_1.recordTitleFieldText.record_title);
        this.icon = "record-title";
        this.iconColor = "#4ECCFD";
        this.placeholder = (0, intl_1.$t)(texts_1.recordTitleFieldText.enter_text_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.recordTitleFieldText.string),
            (0, intl_1.$t)(texts_1.recordTitleFieldText.line),
        ];
        this.uniqueByApplication = true;
        this.fieldDisabledMessage = (0, intl_1.$t)(texts_1.recordTitleFieldText.this_is_a_system_field);
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            contains: comparisons_1.contains,
            not_contains: comparisons_1.notContains,
        };
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = clipboard_1.textPasteRules;
        // recordtitlefield does not have the ability to migrate to another field
        this.migrationRules = {};
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return { required: validation_1.required, max_length: text_field_validators_1.maxLength, unique: uniqueValidator };
    }
    getEmptyValue() {
        return "";
    }
    getInitialFieldValue(startValue) {
        return startValue || this.getEmptyValue();
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            deleteValueOnFirstKeypress: true,
            editorWidth: "100%",
            allowAddRecordToGroup: !field.params.is_auto_generated && !(0, fields_1.isFieldUnique)(field),
            canBulkPaste: () => true,
            canBulkClean(field) {
                return !field.params.is_auto_generated;
            },
        };
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            headerAlignment: "left",
        };
    }
    getFormValidators(field, applicationId, records, record) {
        if (field.params.is_auto_generated) {
            return [];
        }
        return super.getFormValidators(field, applicationId, records, record);
    }
    canChangeValue(field, fromValue, toValue) {
        return (!field.params.is_auto_generated &&
            super.canChangeValue(field, fromValue, toValue));
    }
    valueToExport(fieldValue, field, userPreferences) {
        if (!fieldValue.trim()) {
            return (0, intl_1.$t)(texts_1.recordTitleFieldText.untitled_record);
        }
        return super.valueToExport(fieldValue, field, userPreferences);
    }
    valueToGoogleSheet(fieldValue, field, userPreferences) {
        return (0, google_sheet_1.makeRowDataValues)(this.valueToExport(fieldValue, field, userPreferences), "stringValue");
    }
    showSystemLockIcon(field, view, application, memberAccess) {
        if (view === "grid-cell" && field.params.is_auto_generated) {
            return true;
        }
        return super.showSystemLockIcon(field, view, application, memberAccess);
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison === "is" && filterValue && !field.params.is_auto_generated) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.RecordTitleFieldLogic = RecordTitleFieldLogic;
